import { OpenLevel } from "common/interfaces/OpenLevel";
import { getJsonMasters } from "./common";

export const getOpenLevels = () => getJsonMasters<OpenLevel>("open_levels");
